import vuetify from '@/vue-app/plugins/vuetify';
import TYPES from '@/types';

// Application
import CustomerOverviewService from '@/modules/home-dashboard/customer-overview/application/services/customer-overview-service';

// Domain
import CustomerOverviewState from '@/modules/home-dashboard/customer-overview/domain/state/customer-overview-state';
import Inject from '@/modules/shared/domain/di/inject';
import Translator from '@/modules/shared/domain/i18n/translator';
import { Values } from '@/modules/shared/domain/i18n/types';
import { MessageNotifier } from '@/modules/shared/domain/notifiers/message_notifier';

export default class NavBarViewModel {
  @Inject(TYPES.CUSTOMER_OVERVIEW_SERVICE)
  private readonly customer_overview_service!: CustomerOverviewService;

  @Inject(TYPES.I18N)
  private readonly translator!: Translator;

  @Inject(TYPES.NOTIFIER)
  private readonly message_notifier!: MessageNotifier;

  readonly i18n_namespace = 'home_dashboard';

  customer_overview: CustomerOverviewState = this.customer_overview_service.get_customer_overview();

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  readonly links = [
    { to: '/', icon: 'menu_item.svg', text: 'HomeDashboard' },
    {
      to: vuetify.framework.breakpoint.mdAndUp ? '/profile#personal-information' : '/profile',
      icon: 'menu_item4.svg',
      text: 'Config',
    },
  ]

  menu_items = [
    {
      title: this.translate('my_account'),
      route: '/profile#personal-information',
      action: 'to_my_profile',
    },
    {
      title: this.translate('logout'),
      route: '/login',
      action: 'logout',
    },
  ];

  title = [];

  back_reference = '';

  back_reference_alt = this.translate('back_reference_alt');

  header_box_shadow_active = false;

  show_dialog_sign_out = false;

  show_notifications = false;

  active_notifications = false;

  get initials() {
    const person = this.customer_overview.item.personal_information_overview;
    return `${person.name.charAt(0)}${person.last_name.charAt(0)}`;
  }

  addTitleEventListener = () => {
    window.addEventListener('nav-bar.title', this.updateTitle);
  }

  removeTitleEventListener = () => {
    window.removeEventListener('nav-bar.title', this.updateTitle);
  };

  actionMenu = (action: string, route: string) => {
    if (action === 'logout') {
      this.show_dialog_sign_out = true;
    } else {
      window.location.href = route;
    }
  }

  addScrollListener = () => {
    window.addEventListener('scroll', this.updateHeaderBoxShadowStatus);
  }

  removeScrollListener = () => {
    window.removeEventListener('scroll', this.updateHeaderBoxShadowStatus);
  }

  private updateTitle = (event: CustomEventInit) => {
    this.title = event.detail.title;
    this.back_reference = event.detail.back_reference;
  }

  private updateHeaderBoxShadowStatus = () => {
    this.header_box_shadow_active = window.scrollY > 20;
  }

  handleShowNotifications = () => {
    this.show_notifications = !this.show_notifications;
  }

  activeNotifications = () => {
    this.active_notifications = true;
  }

  hideNotifications = () => {
    this.show_notifications = false;
  }

  verifyIfUserHasAnyProductContracted = () => {
    if (this.customer_overview.item.has_any_product_contracted) {
      const new_link = {
        to: vuetify.framework.breakpoint.mdAndUp ? '/profile#my-documents' : '/profile',
        icon: 'menu_item_document.svg',
        text: 'My documents',
      };
      this.links.splice(1, 0, new_link);
    }
  }

  initialize = async () => {
    this.verifyIfUserHasAnyProductContracted();
  }
}
